import { useMutation, useQueryClient } from 'react-query'
import trailersApi from './actions'
import { trailersKeys } from './constants'

const useTrailersMutations = (companyId: number) => {
  const queryClient = useQueryClient()

  const createTrailer = useMutation(trailersApi.createTrailer, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(trailersKeys.root(companyId))
    },
  })

  const updateTrailer = useMutation(trailersApi.updateTrailer, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(trailersKeys.root(companyId))
    },
  })

  const deleteTrailer = useMutation(trailersApi.deleteTrailer, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(trailersKeys.root(companyId))
    },
  })

  return { createTrailer, updateTrailer, deleteTrailer }
}

export default useTrailersMutations
